import { format } from 'date-fns/format';
import { sha1 } from 'js-sha1';

import { isDefined } from '~/utils/isDefined';

import { Endpoint } from '../../config';

const bin2hex = (b8: Uint8Array) =>
  Array.prototype.map.call(b8, (x) => `0${x.toString(16)}`.slice(-2)).join('');

const MARKERSTART = '|!' as const;
const MARKERS = {
  EMAIL: 'B',
  NAME: 'C',
  DATE: 'D',
  FEEDBACKDATE: 'E',
  DESCRIPTION: 'F',
  LINK: 'G',
  PRODUCTREF: 'H',
  ORDERREF: 'I',
  AMOUNT: 'J',
  CURRENCY: 'K',
  CUSTOMERREF: 'M',
  MERCHANTIDENTIFIER: 'N',
  TAG: 'O',
} as const;

export const feefoSmartLink = ({
  endpoint,
  name = 'QBE',
  email,
  orderRef,
  feedbackDate = '',
  customerRef,
  date,
  currencyId = '5',
  products,
}: {
  endpoint: Endpoint;
  // sharedKey: string;
  // /**
  //  * your feefo merchant identifier. This account must have Smartlink activated for it.
  //  */
  // merchantIdentifier: string;
  // /**
  //  * the customer name
  //  */
  name?: string;
  email: string;
  /** your unique order reference number */
  orderRef: string;
  /** URL to web page of produc
   * t(s) purchased */
  productLinks?: string[];
  /** date on which to ask for feedback - we recommend you do not specify unless overriding option set on feefo */
  feedbackDate?: string;
  /** your customer reference */
  customerRef?: string;
  date?: Date;
  currencyId?: string;
  products: Array<{
    /**
     * product ref(s) of items purchased- usually SKU or equivalent
     */
    ref: string;
    /**
     * description of item purchased
     */
    description: string;
    amount: string;
    link: string;
    tag: string;
  }>;
}) => {
  const pararms = [
    MARKERS.MERCHANTIDENTIFIER + endpoint.merchantIdentifier,
    MARKERS.EMAIL + email,
    MARKERS.NAME + name,
    MARKERS.ORDERREF + orderRef,
    MARKERS.DATE + format(date ?? new Date(), 'yyyy-MM-dd'),
    customerRef && MARKERS.CUSTOMERREF + customerRef,
    feedbackDate && MARKERS.FEEDBACKDATE + feedbackDate,
    currencyId && MARKERS.CURRENCY + currencyId,
    ...products.map((product, index) => MARKERS.DESCRIPTION + (index + 1) + product.description),
    ...products.map((product, index) => MARKERS.PRODUCTREF + (index + 1) + product.ref),
    ...products.map((product, index) => MARKERS.LINK + (index + 1) + product.link),
    ...products.map((product, index) => MARKERS.AMOUNT + (index + 1) + product.amount),
    ...products.map((product, index) => MARKERS.TAG + (index + 1) + product.tag),
  ].filter(isDefined);

  // const key = sha1(`${sha1(`${initialparamsStr}${sharedKey}`)}${sharedKey}`);
  //
  // return `${url}${bin2hex(new TextEncoder().encode(initialparamsStr))}${key}`;

  const paramsStr = pararms.map((param) => MARKERSTART + param).join('');

  const key = sha1(sha1(`${paramsStr}${endpoint.sharedKey}`) + endpoint.sharedKey);

  return `${endpoint.url}${bin2hex(new TextEncoder().encode(paramsStr))}${key}`;
};
